import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Grid2 from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import React from "react";
import { useNavigate } from "react-router-dom";

interface FeatureCard {
  title: string;
  path: string;
  icon: React.ReactNode;
  children?: React.ReactNode;
}

const FeatureCards: React.FC<{
  features: FeatureCard[];
}> = ({ features }) => {
  const navigate = useNavigate();

  return (
    <Grid2 container spacing={4} justifyContent="center" alignItems="center">
      {features.map((feature, index) => (
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
          <Card
            sx={{
              height: 250,
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          >
            <CardActionArea
              onClick={() => navigate(feature.path)}
              sx={{ height: "100%", p: 2 }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    color: "primary.main",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography variant="h6" component="div" align="center">
                  {feature.title}
                </Typography>
                {feature.children}
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default FeatureCards;
